"use client";

import { LogoMark } from "@shared/components/Logo";
import { lazy, Suspense } from "react";
import { DEMO_STORE } from "../site";

/** A question from the hero's field: `id` changes on every ask, so the same words can be asked twice. */
export interface HeroAsk {
	id: number;
	text: string;
}

// The chat, its code and its stylesheet load only once the visitor asks: none of it is in the
// home page's first load.
const DemoStore = lazy(() =>
	import("./DemoStore").then((m) => ({ default: m.DemoStore })),
);

/**
 * The demo store's real chat inside the hero phone, mounted inline (no frame): the visitor's
 * question is sent for them, and the chat answers it like the store's hosted page would.
 */
export function LiveStore({ ask }: { ask: HeroAsk }) {
	return (
		<div className="relative flex h-full flex-col bg-(--mk-white)">
			<Suspense fallback={<StoreOpening />}>
				<DemoStore ask={ask} />
			</Suspense>
		</div>
	);
}

/** Over the phone's screen until the store's chat is ready. */
export function StoreOpening() {
	return (
		<div className="absolute inset-0 grid place-items-center">
			<div className="flex flex-col items-center gap-3 text-(--mk-muted) text-[13px]">
				<LogoMark className="mk-float size-12" />
				Opening {DEMO_STORE.name}…
			</div>
		</div>
	);
}
